import { render } from "./healthrecord.vue?vue&type=template&id=6be2887c&scoped=true"
import script from "./healthrecord.vue?vue&type=script&lang=js"
export * from "./healthrecord.vue?vue&type=script&lang=js"

import "./healthrecord.vue?vue&type=style&index=0&id=6be2887c&scoped=true&lang=css"

import exportComponent from "D:\\DAIHAO\\AAAAA\\smart_brain_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be2887c"]])

export default __exports__